module.exports = __webpack_public_path__ + "media/images/education/content-image-b2c54b9ce5e34bf5570cbb0129108f5b.jpg";